export const styles = {
    paper: {
        width: '90vw',
        maxWidth: 500
    }
};
